import { appConfig } from '../../../config/customization';
import Device from '../../../constants/deviceSizes';

const borderStyle = `1px solid ${appConfig.colors.bordersGray}`;

export default {
  configurationContainer: {
    borderBottom: borderStyle,
    borderRight: 0,
    borderLeft: 0,
    paddingTop: 15,
    [Device.mobile]: {
      padding: '10px 10px 0px'
    }
  },
  userRow: {
    backgroundColor: appConfig.colors.userInfoOddRow
  },
  thirdHeader: {
    marginBottom: 5
  },
  userInfoRow: {
    backgroundColor: appConfig.colors.userInfoEvenRow
  },
  emailContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  email: {
    marginRight: 10
  }
};
